import React from "react";
import {
  StyleSheet,
  TouchableOpacity,
  View,
  Image,
  ImageBackground,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { useNavigation } from "@react-navigation/native";
import { DrawerActions } from "@react-navigation/native";

import GullakIcon from "@assets/svg/GullakIcon";
import HamburgerIcon from "@assets/svg/Hamburger";
import Text from "@components/CustomText";
import t from "@constants/localization";
import toCapitalize from "@utils/toCapitalize";
import testIds from "../../constants/testIds";
import { actions as walletActions } from "@reducers/walletReducer";
import { scale, ScaledSheet } from "@utils/scale";

const PATH = "screens/Home/Header";

const Header = () => {
  const navigation = useNavigation();
  const user = useSelector(({ auth }) => auth?.user);
  const config = useSelector(({ configReducer }) => configReducer);
  const partnerImg = user?.user_image || "";
  const isCpDb = user?.cp_db_id;
  const isWalletEnabled = config?.isWalletEnabled;
  const name = isCpDb ? user?.db_name : user?.name;
  const dispatch = useDispatch();

  return (
    <>
      <ImageBackground
        source={require("@assets/images/header/header_background.png")}
        resizeMode="cover"
        style={styles.background}
      >
        <View style={styles.container}>
          <View testID={testIds.hamburger_drawer}>
            <TouchableOpacity
              testID="hs-hamburger"
              onPress={() => navigation.dispatch(DrawerActions.toggleDrawer())}
              style={styles.hamburgerIconBtn}
            >
              <HamburgerIcon color="#000000" />
            </TouchableOpacity>
          </View>
          {!isCpDb && partnerImg ? (
            <TouchableOpacity
              testID="hs-profile"
              activeOpacity={0.5}
              onPress={() => navigation.navigate("ProfileInfo")}
            >
              <Image source={{ uri: partnerImg }} style={styles.profileImage} />
            </TouchableOpacity>
          ) : (
            <View style={styles.profileImageBg}>
              <Text style={styles.avatarTxt}>
                {toCapitalize((name && name.substring(0, 1)) || "")}
              </Text>
            </View>
          )}
          <View style={styles.header}>
            <Text style={styles.greeting}>{t(`${PATH}/greeting`)}</Text>
            <Text style={styles.name} numberOfLines={2}>
              {toCapitalize((name && `${name}`) || "")}
            </Text>
          </View>
          <View style={styles.iconContainer}>
            {/* Wallet Button */}
            {isWalletEnabled ? (
              <TouchableOpacity
                testID="rvc-gullak"
                onPress={() => {
                  dispatch(walletActions.resetFilters());
                  navigation.navigate("WalletBalance");
                }}
              >
                <View style={styles.gullakContainer}>
                  <GullakIcon fill="rgba(25, 129, 85, 1)" />
                  <Text style={styles.gullakText}>{t(`${PATH}/wallet`)}</Text>
                </View>
              </TouchableOpacity>
            ) : null}
          </View>
        </View>
      </ImageBackground>
    </>
  );
};

const styles = ScaledSheet.create({
  background: {
    flexDirection: "row",
    alignItems: "center",
  },
  container: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
  },
  hamburgerIconBtn: {
    marginRight: 16,
    justifyContent: "center",
    alignItems: "center",
  },
  header: {
    flexDirection: "column",
    flex: 1,
  },
  profileImage: {
    width: scale(60),
    height: scale(60),
    borderRadius: 18,
    backgroundColor: "lightgray",
  },
  profileImageBg: {
    width: scale(60),
    height: scale(60),
    backgroundColor: "lightgray",
    borderRadius: 18,
    justifyContent: "center",
    alignItems: "center",
  },
  avatarTxt: {
    fontSize: 24,
    fontWeight: "bold",
  },
  greeting: {
    fontSize: 18,
    marginLeft: 12,
  },
  name: {
    fontSize: 20,
    fontWeight: "bold",
    marginLeft: 12,
  },
  iconContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  earningsContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "rgba(25, 129, 85, 1)",
    borderRadius: 24,
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
  earningsText: {
    fontSize: 14,
    paddingHorizontal: 4,
    lineHeight: 20,
  },
  gullakContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "rgba(25, 129, 85, 1)",
    borderRadius: 24,
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
  gullakText: {
    fontSize: 14,
    paddingHorizontal: 4,
    lineHeight: 20,
  },
});

export default Header;
